const s = {
  JPEG: "image/jpeg",
  PNG: "image/png",
  PDF: "application/pdf",
  TXT: "text/plain",
  JSON: "application/json",
  DICOM: "application/dicom",
  OCTET_STREAM: "application/octet-stream"
};
function p(e) {
  const t = e.split(",")[1], i = atob(t), o = new ArrayBuffer(i.length), n = new Uint8Array(o);
  for (let a = 0; a < i.length; a++)
    n[a] = i.charCodeAt(a);
  const r = e.match(/^data:([^;]+);/)[1];
  return new Blob([o], { type: r });
}
function l(e, t) {
  return new File([e], t, {
    type: e.type,
    lastModified: Date.now()
  });
}
const c = new RegExp("(?<!^)\\.([^.]+)$");
function g(e) {
  return c.exec(e)?.[1] ?? "";
}
function m(e, t) {
  const o = e.querySelector("canvas").toDataURL("image/png"), n = p(o), r = n.type === "image/png" ? "png" : (n.type === "image/jpeg", "jpg");
  return l(
    n,
    t.replace(c, `.${r}`)
  );
}
export {
  s as MimeTypes,
  l as blobToFile,
  p as dataURItoBlob,
  m as extractImageFromCanvas,
  c as fileExtensionRegExp,
  g as getFileExtension
};
